import { OrganizationContact } from '@prisma/client'

export const getNames = (contact: OrganizationContact) => {
  const short = contact.firstname ?? contact.lastname ?? contact.email
  const name = [contact.firstname, contact.lastname].filter(Boolean).join(' ')

  const full = [contact.firstname, contact.lastname, contact.email]
    .filter(Boolean)
    .join(' ')

  return {
    short,
    name,
    full,
  }
}
